import { jsx } from "panel";
import { SvgIconEl } from "common/components/svg-icon";
import timing from "common/stylesheets/mixins/timing.json";
import { TooltipEl } from "common/components/tooltip";
import { SelectTheme } from "common/components/select/constants";
import { SelectEl } from "common/components/select";
import { UserIconEl } from "common/widgets/user-icon";
import { IconSizeType } from "common/constants";
import { Placement } from "common/components/tooltip/types";
import { SIZE, TEXT_HIGHLIGHT_THEME, TextHighlightEl } from "common/components/text-highlight";
import { Directions } from "common/components/drop-menu/types";
import { handleKeyPress } from "common/util/focusable";
import { ButtonEl } from "common/components/button";
import { ButtonSize, ButtonTheme } from "common/components/button/constants";
import { DropPosition } from "../constants";
import { NestingOrder } from "../types";
export function template() {
  var _this$iconRenderer;
  const dragHandlers = this.attr("is-drag-disabled") ? {} : {
    dragover: this.helpers.onDragOver,
    dragleave: this.helpers.onDragLeave,
    drop: this.helpers.onDrop,
    dragstart: this.helpers.onDragStart,
    dragend: this.helpers.onDragEnd
  };
  const item = this.state.item;
  const isFirstInNestingOrder = this.attr("nested-order") === NestingOrder.First;
  const isLastInNestingOrder = (this.attr("nested-order") === NestingOrder.Last || this.attr("nested-order") === NestingOrder.First) && (!this.attr("is-expanded") || !item.nestedItems || item.nestedItems.length === 0);
  return /* @__PURE__ */ jsx("div", { sel: ".draggable-wrapper", class: {
    "is-draggable": this.attr("is-draggable"),
    "is-drag-disabled": this.attr("is-drag-disabled"),
    "is-dragging": this.state.isDragging,
    "drop-indicator-above": this.state.dropPosition === DropPosition.Above,
    "drop-indicator-below": this.state.dropPosition === DropPosition.Below,
    "drop-indicator-on": this.state.dropPosition === DropPosition.On
  }, attrs: {
    draggable: String(!this.attr("is-drag-disabled") && this.attr("is-draggable") && !this.state.isOverflowMenuOpen)
  }, on: dragHandlers, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(
    "a",
    {
      sel: ".item-wrapper",
      attrs: {
        elref: "sidenavItemLink",
        tabindex: 0,
        href: item === null || item === void 0 ? void 0 : item.href,
        target: item === null || item === void 0 ? void 0 : item.target,
        draggable: "false"
      },
      class: {
        "is-selected": this.attr("is-selected"),
        "has-overflow-menu": this.helpers.hasOverflowMenu(),
        "no-top-border-radius": this.attr("is-selected") && !isFirstInNestingOrder,
        "no-bottom-border-radius": this.attr("is-selected") && !isLastInNestingOrder
      },
      on: {
        click: this.helpers.onClick,
        keypress: handleKeyPress
      }
    },
    (_this$iconRenderer = this.iconRenderer) === null || _this$iconRenderer === void 0 ? void 0 : _this$iconRenderer.call(this),
    /* @__PURE__ */ jsx("div", { sel: ".item", style: {
      width: "calc(100% - ".concat(this.attr("label-tab-size") * 10 + (this.attr("is-new") ? 44 : 0), "px)"),
      marginLeft: "".concat(this.attr("label-tab-size") * 10, "px")
    }, attrs: {
      draggable: "false"
    }, class: {
      "is-new": this.attr("is-new")
    } }, this.attr("can-expand") && /* @__PURE__ */ jsx(ButtonEl, { sel: ".caret-btn", attrs: {
      icon: this.attr("is-expanded") ? "caret-down" : "caret-right",
      size: ButtonSize.Inline,
      theme: ButtonTheme.Tertiary
    }, on: {
      click: (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        this.helpers.onCaretClick();
      }
    } }), /* @__PURE__ */ jsx("div", { sel: ".tooltip-container" }, item.icon && /* @__PURE__ */ jsx("div", { sel: ".item-icon" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
      icon: item.icon
    } })), /* @__PURE__ */ jsx("div", { sel: ".item-label" }, this.print(item.label)), item.iconRight && /* @__PURE__ */ jsx("div", { sel: ".item-right-icon" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
      icon: item.iconRight,
      height: "18px"
    } })), item.tag && /* @__PURE__ */ jsx("span", { sel: ".item-tag-wrapper" }, /* @__PURE__ */ jsx(TextHighlightEl, { attrs: {
      text: item.tag,
      size: SIZE.SMALL,
      theme: TEXT_HIGHLIGHT_THEME.INFORMATION
    } })), !this.state.isOverflowMenuOpen && /* @__PURE__ */ jsx(TooltipEl, { attrs: {
      placement: Placement.Right,
      "delay-in": timing["$mp-slow-tooltip-delay-in"],
      offset: 38
    } }, /* @__PURE__ */ jsx("div", { sel: ".tooltip" }, /* @__PURE__ */ jsx("div", { sel: ".tooltip-label" }, item.tooltip ? this.print(item.tooltip) : this.print(item.label)), item.userName && /* @__PURE__ */ jsx("div", { sel: ".user-metadata" }, /* @__PURE__ */ jsx(UserIconEl, { attrs: {
      name: item.userName,
      "disable-tooltip": true,
      id: item.userId,
      size: IconSizeType.Small,
      email: item.userEmail,
      "include-label": true
    } }))))), this.helpers.hasOverflowMenu() && /* @__PURE__ */ jsx("div", { sel: ".overflow-menu-wrapper", class: {
      "is-selected": this.attr("is-selected")
    }, on: {
      click: (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
      }
    } }, /* @__PURE__ */ jsx(SelectEl, { sel: ".overflow-menu", class: {
      "is-selected": this.attr("is-selected")
    }, attrs: {
      theme: SelectTheme.Builder,
      icon: {
        leftIcon: "hor-ellipsis"
      },
      "icon-only": true,
      "menu-width": 180,
      "menu-height": 440,
      "menu-alignment": Directions.Right,
      "show-preview-tooltip": true,
      "experimental-positioning": true
    }, props: {
      sections: item.overflowMenuSections
    }, on: {
      change: this.helpers.onOverflowMenuSelect,
      menuChange: this.helpers.onOverflowMenuChange
    } }))),
    this.attr("is-new") && /* @__PURE__ */ jsx(TextHighlightEl, { sel: ".new-badge", attrs: {
      text: "New",
      theme: TEXT_HIGHLIGHT_THEME.INFORMATION
    } })
  ));
}
